<template>
    <div class="statistics statistics__home" v-if="this.Renderizou">
        <div class="d-flex justify-content-center align-items-center dashboard" v-if="this.Estatisticas == 'Não Possui Investimentos'">
            <div class="dashboard__complete">
                <div class="row">
                    <div class="col-12 text-center">
                        <div>
                            <h1>Minhas estatísticas</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center align-items-center dashboard" v-if="this.Estatisticas == 'Loading'">
            <div class="dashboard__complete">
                <div class="row">
                    <div class="col-12 text-center">
                        <div>
                            <h1>Carregando...</h1>
                            <div class="loader"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row show-mobile">
            <div class="col-12">
                <div class="alert alert-warning" role="alert">
                    Para ter acesso completo as estátisticas da plataforma acesse a partir de um desktop ou notebook.
                </div>
            </div>
        </div>

        <div class="box mb-4" v-if="this.Estatisticas == 'Possui Investimentos' && this.Renderizou == true && showMeInfo()" >
            <div class="row no-gutters">
                <div class="col-12 col-md-7 col-lg-8 d-flex align-items-start flex-column box-left hide-mobile">
                    <div class="p-3 p-md-4 w-100 mb-auto">
                        <h2>Meus investimentos</h2>
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Investimentos atrasados</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Investimentos por score</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade pt-3 active show" id="home" role="tabpanel" aria-labelledby="home-tab">
                               <canvas id="GraficoInvestimentos" class="box box_chart" style="margin-top:10%;"></canvas>
                            </div>
                            <div class="tab-pane fade pt-3" id="profile" role="tabpanel" aria-labelledby="profile-tab">                               
                                <canvas id="GraficoInvestimentosScores" style="margin-top:10%;"></canvas>
                            </div>
                        </div>
                    </div>
                    <div class="foot align-self-end">
                        <div class="row no-gutters align-items-center">
                            <div class="col-12 col-md-6 foot-item" v-if="Renderizou == true">
                                <div class="p-3 p-lg-6">
                                    <label>Investimentos em empréstimos coletivos</label>
                                    <strong>R$ {{money(TipoInvestimento.Coletivo.Valor)}}</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 foot-item" v-if="Renderizou == true">
                                <div class="p-3 p-md-6">
                                    <label>Investimentos em empréstimos de impacto</label> 
                                    <strong>R$ {{money(TipoInvestimento.Impacto.Valor)}}</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 foot-item lower-item" v-if="Renderizou == true">
                                <div class="p-3 p-md-6">
                                    <label>Investimentos em empréstimos antecipação</label>
                                    <strong>R$ {{money(TipoInvestimento.Antecipacao.Valor)}}</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 foot-item lower-item" v-if="Renderizou == true">
                                <div class="p-3 p-md-6">
                                    <label>Investimentos em empréstimos sociais</label>
                                    <strong>R$ {{money(TipoInvestimento.Social.Valor)}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 col-lg-4 box-right" v-if="Renderizou == true">
                    <div class="p-3 p-md-4">
                        <h3>Total de investimentos <at-popover trigger="hover" placement="right" content="São considerados apenas investimentos com oportunidades finalizadas, ou seja, as reservas de investimento somente são adicionadas após a oportunidade encerrada e o investimento confirmado.">
                            <i style="font-size:14px" class="fas fa-info-circle"></i>
                            </at-popover><span>{{Rendimento.TotalInvestimentos.Numero}}</span>
                        </h3>
                        
                        <ul class="values">
                            <li>
                                <span>Atual 
                                    <at-popover trigger="hover" placement="right" content="Investimentos com pagamentos pendentes a receber que estão em dia.">
                                        <i style="font-size:14px" class="fas fa-info-circle"></i>
                                    </at-popover>
                                </span>
                                <span v-if="valor">R$ {{money(Rendimento.AReceber.Valor - ValorExpirados)}}</span>
                                <span v-else>{{Rendimento.AReceber.Numero - Atrasados.Numero}}</span>
                            </li>
                            <li>
                                <span>Período de carência 
                                    <at-popover trigger="hover" placement="right" content="Corresponde ao período compreendido entre a concessão do empréstimo e o pagamento da primeira amortização + juros.">
                                        <i style="font-size:14px" class="fas fa-info-circle"></i>
                                    </at-popover>
                                </span>
                                <span v-if="valor">R$ {{money(Carencia.Valor)}}</span>
                                <span v-else>{{Carencia.Numero}}</span>
                            </li>
                            <li>
                                <span>1-15 dias de atraso 
                                    <at-popover trigger="hover" placement="right" content="Seus investimentos que estão com 1 a 15 dias de atraso.">
                                        <i style="font-size:14px" class="fas fa-info-circle"></i>
                                    </at-popover>
                                </span>
                                <span v-if="valor">R$ {{money(Atrasados.Reservas.Atrasados1.Valor)}}</span>
                                <span v-else>{{Atrasados.Reservas.Atrasados1.Numero}}</span>
                            </li>
                            <li>
                                <span>16-30 dias de atraso 
                                    <at-popover trigger="hover" placement="right" content="Seus investimentos que estão com 16 a 30 dias de atraso.">
                                        <i style="font-size:14px" class="fas fa-info-circle"></i>
                                    </at-popover>
                                </span>
                                <span v-if="valor">R$ {{money(Atrasados.Reservas.Atrasados2.Valor)}}</span>
                                <span v-else>{{Atrasados.Reservas.Atrasados2.Numero}}</span>
                            </li>
                            <li>
                                <span>31 a 60 dias de atraso 
                                    <at-popover trigger="hover" placement="right" content="Seus investimentos que estão com 31 a 60 dias de atraso.">
                                        <i style="font-size:14px" class="fas fa-info-circle"></i>
                                    </at-popover>
                                </span>
                                <span v-if="valor">R$ {{money(Atrasados.Reservas.Atrasados3.Valor)}}</span>
                                <span v-else>{{Atrasados.Reservas.Atrasados3.Numero}}</span>
                            </li>
                            <li>
                                <span>+60 dias de atraso 
                                    <at-popover trigger="hover" placement="right" content="Os pagamentos para estes empréstimos estão com mais de 60 dias de atraso. Existe uma expectativa razoável de que o mutuário será capaz de trazer o empréstimo de volta ao status atual.">
                                        <i style="font-size:14px" class="fas fa-info-circle"></i>
                                    </at-popover>
                                </span>
                                <span v-if="valor">R$ {{money(Atrasados.Reservas.Expirado.Valor)}}</span>
                                <span v-else>{{Atrasados.Reservas.Expirado.Numero}}</span>
                            </li>
                            <li>
                                <span>Total</span>
                                <span v-if="valor">R$ {{money(Atrasados.Valor + Rendimento.AReceber.Valor + Carencia.Valor - ValorExpirados)}}</span>
                                <span v-else>{{Rendimento.AReceber.Numero + Carencia.Numero}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="foot">
                        <div class="p-3 p-md-4">
                            <h3>Investimentos por Score <at-popover trigger="hover" placement="right"></at-popover></h3>
                            <ul class="rating score">
                                <li>
                                    <span class="item"><i class="dot rating-aa"></i> AA</span>
                                    <span v-if="valor">R$ {{money(Scores.AA.Valor)}}</span>
                                    <span v-else>{{Scores.AA.Numero}}</span>
                                </li>
                                <li>
                                    <span class="item"><i class="dot rating-a"></i> A</span>
                                    <span v-if="valor">R$ {{money(Scores.A.Valor)}}</span>
                                    <span v-else>{{Scores.A.Numero}}</span>
                                </li>
                                <li>
                                    <span class="item"><i class="dot rating-b"></i> B</span>
                                    <span v-if="valor">R$ {{money(Scores.B.Valor)}}</span>
                                    <span v-else>{{Scores.B.Numero}}</span>
                                </li>
                                <li>
                                    <span class="item"><i class="dot rating-c"></i> C</span>
                                    <span v-if="valor">R$ {{money(Scores.C.Valor)}}</span>
                                    <span v-else>{{Scores.C.Numero}}</span>
                                </li>
                                <li>
                                    <span class="item"><i class="dot rating-d"></i> D</span>
                                    <span v-if="valor">R$ {{money(Scores.D.Valor)}}</span>
                                    <span v-else>{{Scores.D.Numero}}</span>
                                </li>   
                                <li>
                                    <span class="item"><i class="dot rating-e"></i> E</span>
                                    <span v-if="valor">R$ {{money(Scores.E.Valor)}}</span>
                                    <span v-else>{{Scores.E.Numero}}</span>
                                </li>
                                <li> 
                                    <span class="item"><i class="dot rating-hr"></i> HR</span>
                                    <span v-if="valor">R$ {{money(Scores.HR.Valor)}}</span>
                                    <span v-else>{{Scores.HR.Numero}}</span>
                                </li>
                            </ul>

                            
                        </div>
                        <div class="p-3 p-md-4">
                            <div class="d-flex pt-4">
                                <div class="form-check pr-4">
                                    <input id="valor" type="radio" name="tipo" class="option-input radio" v-model="valor" v-bind:value="true" :checked="true">
                                    <label for="valor">Por valores</label>
                                </div>
                                <div class="form-check">
                                    <input id="num" type="radio" name="tipo" class="option-input radio" v-model="valor">
                                    <label for="num">Por números</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="box mb-4" v-if="Estatisticas == 'Possui Investimentos' && Renderizou == true && showMeInfo()" >
            <div class="row no-gutters">
                <div class="col-12 col-md-12 col-lg-12 d-flex align-items-start flex-column box-item hide-mobile">
                    <div class="p-3 p-md-4 w-100 mb-auto">
                        <h4 style="margin-bottom:5%">Rendimento Geral da Carteira</h4>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade pt-3 active show" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <canvas id="GraficoRendimentoGeral" class="box box_chart"  style="margin:auto; max-height: 550px; width:100%;"></canvas>
                            </div>
                        </div>
                    </div>
                    <div class="foot align-self-end">
                        <div class="row no-gutters align-items-center">
                            <div class="col-12 col-md-3 foot-item" v-if="Renderizou == true">
                                <div class="p-3 p-lg-3">
                                    <label>Total Investido</label>
                                    <strong>R$ {{money(Rendimento.Investido.Valor)}}</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-3 foot-item" v-if="Renderizou == true">
                                <div class="p-3 p-md-3">
                                    <label>Rendimento Esperado</label> 
                                    <strong>R$ {{money(Rendimento.TotalInvestimentos.Valor)}}</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-2 foot-item" v-if="Renderizou == true">
                                <div class="p-3 p-md-3">
                                    <label>Previsão a receber próximo mês</label>
                                    <strong>R$ {{money(ProximoMes.Valor + EsteMes.Valor)}}</strong>
                                </div>
                            </div> 
                            <div class="col-12 col-md-2 foot-item" v-if="Renderizou == true">
                                <div class="p-3 p-md-3">
                                    <label>Rendimento sobre CDI</label>
                                    <strong>{{CDI.toFixed(2)}}%</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-2 foot-item" v-if="Renderizou == true">
                                <div class="p-3 p-md-3">
                                    <label>Taxa interna de retorno (T.I.R.)</label>
                                    <strong>{{TIR.toFixed(2)}}%</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="box" v-if="Estatisticas == 'Possui Investimentos' && Renderizou == true && showMeInfo()" >
            <div class="row no-gutters">             
                <!-- <div class="d-flex align-items-start flex-column box-item">
                    <div class="p-3 p-md-4 w-100 mb-auto hide-mobile">
                        <h4>Rendimento geral da carteira</h4>
                    </div>
                    <canvas id="GraficoRendimentoGeral"></canvas>
                    <modal v-if="ShowModalRendimento" @close="ShowModalRendimento = false">
                       <div slot="header">
                           <h3>Rendimento geral da carteira: </h3> 
                       </div>
                       <div class="Legenda" slot="body">
                           <span><div class="ValorTotalInvestido"></div> <b>Valor Total Investido:</b> Corresponde a somatória de todos o investimentos efetuados.</span>
                           <br>
                           <span><div class="RendimentoRecebido"></div> <b>Rendimento Recebido:</b> Corresponde as parcelas de juros recebida de acordo com o pagamento do tomador.</span>
                           <br>
                           <span><div class="RendimentoAtrasado"></div> <b>Rendimento em Atraso:</b> Corresponde as parcelas de juros em atraso de acordo com o pagamento do tomador.</span>
                           <br>
                           <span><div class="RendimentoReceber"></div> <b>Rendimento a Receber:</b> Corresponde as parcelas de juros que estão pendentes.</span>
                           <br>
                           <span><div class="MultasAtrasos"></div> <b>Multas e Atrasos:</b> Corresponde ao valor excedente pago pelo tomador devido ao atraso das parcelas.</span>
                           <br>
                           <br>
                           <span class="LegendaFooter"><b>* Valores calculados de acordo com a tabela price.</b></span>
                       </div>
                    </modal>
                    <i v-on:click="ShowModalRendimento = true" style="margin:auto 10px auto auto; color:#323271" class="InfoGrafico far fa-question-circle"></i>
                    <div class="foot align-self-end">
                        <div class="row no-gutters align-items-center">
                            <div class="col-12 col-md-4 foot-item">
                                <div class="p-3 p-md-4">
                                    <label>Total investido</label>
                                    <strong>R$ {{money(Estatisticas.TotalInvestido)}}</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 foot-item">
                                <div class="p-3 p-md-4">
                                    <label>Rendimento esperado</label>
                                    <strong>R$ {{money(Estatisticas.TotalRendimentoEsperado)}}</strong>
                                </div>
                            </div>
                            <div class="col-12 col-md-4 foot-item">
                                <div class="p-3 p-md-4">
                                    <label>Rendimento sobre CDI</label>
                                    <strong>{{porcentagemCdi(Estatisticas.MediaCdi)}}%</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="p-3 p-md-4 hide-mobile" style="border: 1px solid #ddd; border-radius: 5px; margin-right: 15px; width:100%; height:auto">
                    <h4 style="margin-bottom:5%">Rendimento por tipo de investimento</h4>
                    <canvas width="269px" height="180px" id="GraficoRendimentoTipo" style="margin:auto; max-height: 450px; max-width: 900px;"></canvas>
                    <modal v-if="ShowModalInvestimento" @close="ShowModalInvestimento = false">
                        <div slot="header">
                            <h3>Rendimento por tipo de investimento:</h3>
                        </div>
                        <div slot="body">
                            <div class="Legenda" slot="body">
                                <span><div class="RendimentoRecebido"></div> <b>Investimento Amortizado:</b> Corresponde as parcelas amortizadas recebidas de acordo com o pagamento do tomador.</span>
                                <br>
                                <span><div class="RendimentoAtrasado"></div> <b>Investimento Atrasado:</b> Corresponde as parcelas amortizadas atrasadas de acordo com o pagamento do tomador.</span>
                                <br>
                                <span><div class="ValorTotalInvestido"></div> <b>Investimento a Receber:</b> Corresponde as parcelas amortizadas que estão pendentes.</span>
                                <br>
                                <span><div class="RendimentoReceber"></div> <b>Rendimento:</b> Corresponde ao total de rendimento esperado.</span>
                                <br>
                                <br>
                                <span class="LegendaFooter"><b>* Valores calculados de acordo com a tabela price.</b></span>
                            </div>
                        </div>
                    </modal>
                    <i v-on:click="ShowModalInvestimento = true" style="margin-left:99%; color:#323271" class="InfoGrafico far fa-question-circle"></i>
                </div> -->
            </div>
        </div>

        <div class="mt-4 p-3 p-md-4 box box-item-full hide-mobile" v-if="Estatisticas == 'Possui Investimentos' && Renderizou == true && showMeInfo()">
            <h4>Rendimentos por investimento</h4>

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" style="text-align:left;">ID</th>
                            <th scope="col">Score</th>
                            <th scope="col">Valor investido @ Retorno %</th>
                            <th scope="col">Rendimento sobre CDI</th>
                            <th scope="col">Data do invest.</th>
                            <th scope="col">Duração</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr @click="linkReserva(Reserva._id)" v-for="Reserva in HistoricoReservas" :key="Reserva.IDOportunidade">
                            <th scope="row" style="cursor:pointer" class="text-secondary">
                                <at-popover trigger="hover" placement="top" :content="NomeEmpresa(Reserva.NomeEmpresa)">
                                    {{ajustIdOportunidade(Reserva.IDOportunidade,5)}}
                                </at-popover>
                            </th>
                            <td class="rating score"><span class="item"><i :class="lowerCase(Reserva.Score)"></i>{{ajustaScore(Reserva.Score)}}</span></td>
                            <td>
                                <div>
                                    R$ {{money(Reserva.Valor)}} @ {{Reserva.TaxaRetornoAA}}% a.a.
                                    <span class="grafico">
                                        <span class="grafico-bar" style="width: 100%"></span>
                                        <span class="grafico-bar" :style="PorcentagemRendimento(Reserva.Valor , Reserva.TaxaRetornoAA)"></span>
                                    </span>
                                </div>
                            </td>
                            <td>{{Reserva.RendimentoCDI}}% a.a.</td>
                            <td>{{formatDate(Reserva.Created)}}</td>
                            <td>{{Reserva.Prazo}} meses</td>
                            <td><span :class="Status(Reserva.Status)">{{TextoStatus(Reserva.Status)}}</span></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <th colspan="7" class="text-center" v-if="!VisualizarTodos && AuxHistoricoReservas.length > 5">
                            <button @click="MostraInvestimentos()" class="btn btn-lg btn-link text-secondary">Visualizar todos os investimentos</button>
                        </th>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="d-flex justify-content-center align-items-center dashboard">
            <no-data-profile v-if="!showMeInfo()" :Msg="showMeMsg"></no-data-profile>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import Modal from "@/components/Modal";
    import ApiClientGo from "@/utils/api-client-go";
    import * as mutationTypes from '@/store/mutation-types.js'
    import NoDataProfile from '@/components/NoDataProfile'
    
    export default {
        components: { 
           Modal ,
           NoDataProfile
        },
        ready () {
            this.legendMarkup = this._chart.generateLegend()
        },
        data() {
            return {
                valor: true,
                User: null,
                Estatisticas: "Loading",
                Renderizou: true,
                GraficoInvestimentos: true,
                Criou: false,
                Solicitacoes: [],
                VisualizarTodos: false,
                ShowModalRendimento: false,
                ShowModalInvestimento: false,
                showMeMsg: 3,

                TIR:0,
                CDI:0,

                Scores:null,
                TipoInvestimento:null,
                Rendimento:null,

                Atrasados:null,
                ProximoMes:null,
                EsteMes:null,
                Carencia:null,

                HistoricoReservas:null,
                AuxHistoricoReservas:null,

                ValorExpirados:0
            }
        },
        computed:{
            AtrasosExpirados(){
                return 
            }
        },
        methods:{
            money(n) {
                var c = 2,
                    d = ",",
                    t = ".",
                    s = n < 0 ? "-" : "",
                    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
                    j = (j = i.length) > 3 ? j % 3 : 0;
                return (
                    s +
                    (j ? i.substr(0, j) + t : "") +
                    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
                    (c
                    ? d +
                        Math.abs(n - i)
                        .toFixed(c)
                        .slice(2)
                    : "")
                );
            },
            porcentagemCdi(n) {
                var c = 0,
                    d = ",",
                    t = ".",
                    s = n < 0 ? "-" : "",
                    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
                    j = (j = i.length) > 3 ? j % 3 : 0;
                return (
                    s +
                    (j ? i.substr(0, j) + t : "") +
                    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
                    (c
                    ? d +
                        Math.abs(n - i)
                        .toFixed(c)
                        .slice(2)
                    : "")
                );
            },
            ajustIdOportunidade(id, qtd) {
                var s = String(id);
            
                if(id == undefined || id == 0)
                return "";

                while (s.length < (qtd || 2)) {
                    s = "0" + s;
                }
                return "#"+s;
            },
            formatDate(date) {
                let dateaux = date.split("T")
				let dateArray = dateaux[0].split('-')
				let day = dateArray[2]
				let month = dateArray[1]
				let year = dateArray[0]

				return day + "/" + month + "/" + year;
            },
            lowerCase(texto) {
                if (texto == null || texto == undefined || texto == "") return "-";

                if (texto == "AA" || texto == "HR") return "dot rating-" + texto.toLowerCase();

                if (texto == "Social") return "dot socialrating" 

                return "dot rating-" + texto[0].toLowerCase();
            },
            ajustaScore(score) {
                if (score == null || score == undefined || score == "") return "-"

                if (score == "AA" || score == "HR") return score

                if (score == "Social") return "SO"

                return score[0]
            },
            PorcentagemRendimento(Investido, Rendimento){
                Rendimento = Investido * (1 + Rendimento/100)
                var porcentagem = Rendimento * 100 / Investido
                return "width:" +  Math.round(porcentagem) + "%"
            },
            MostraInvestimentos(){
                if(!this.VisualizarTodos) {
                    this.HistoricoReservas = this.AuxHistoricoReservas
                    this.VisualizarTodos = true
                }   
                return
            },
            CriaGrafico: function () { 
                // Bar chart Investimentos por Score
                new Chart(document.getElementById("GraficoInvestimentosScores"), {
                    type: 'bar',
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: "AA",
                                backgroundColor: ["#C1CF2E"],
                                data: [this.Scores.AA.Valor.toFixed(2)]
                            },
                            {
                                label: "A",
                                backgroundColor:["#2DC2BF"],
                                data: [this.Scores.A.Valor.toFixed(2)]
                            },
                            {
                                label: "B",
                                backgroundColor:["#6FC30D"],
                                data: [this.Scores.B.Valor.toFixed(2)]
                            },
                            {
                                label: "C",
                                backgroundColor:["#F04887"],
                            data: [this.Scores.C.Valor.toFixed(2)]
                            },
                            {
                                label: "D",
                                backgroundColor:["#FFB928"],
                                data: [this.Scores.D.Valor.toFixed(2)]
                            },
                            {
                                label: "E",
                                backgroundColor:["#FD615D"],
                                data: [this.Scores.E.Valor.toFixed(2)]
                            },
                            {
                                label: "HR",
                                backgroundColor:["#B61843"],
                                data: [this.Scores.HR.Valor.toFixed(2)]
                            },
                            {
                                label: "Social",
                                backgroundColor:["#52B3D9"],
                                data:[this.TipoInvestimento.Social.Valor.toFixed(2)]
                            },
                        ]
                    },
                    options: {
                        tooltips: {
                            enabled: true,
                            mode: 'single',
                            callbacks: {
                                label: (tooltipItems,data) => data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) 
                            }
						},
                        legend: { 
                            display: true,
                            position: "bottom"
                        },
                        title: {
                        display: false,
                        text: 'Investimentos por score'
                        },
                        responsive: true,
                        scales: {
                            xAxes: [{
                            gridLines: {
                                display: false
                            }
                            }],
                            yAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function(label, index, labels) {
                                                    if(label == '0') {
                                                        return '0'
                                                    }
                                                    return 'R$ ' + label.toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 2}) 
                                                }
                            }
                            }]
                        },
                    }
                });

                // Bar chart Investimentos 
                new Chart(document.getElementById("GraficoInvestimentos"), {
                    type: 'bar',
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: "Atual",
                                backgroundColor: ["#FF8600"],
                                data: [this.Rendimento.AReceber.Valor.toFixed(2)]
                            },
                            {
                                label: "Período de carência",
                                backgroundColor:["#FF441D"],
                                data: [this.Carencia.Valor.toFixed(2)]
                            },
                            {
                                label: "1-15 dias de atraso",
                                backgroundColor:["#DC0033"],
                                data: [this.Atrasados.Reservas.Atrasados1.Valor.toFixed(2)]
                            },
                            {
                                label: "16-30 dias de atraso",
                                backgroundColor:["#A1003D"],
                                data: [this.Atrasados.Reservas.Atrasados2.Valor.toFixed(2)]
                            },
                            {
                                label: "31-60 dias de atraso",
                                backgroundColor:["#5A0C4C"],
                                data: [this.Atrasados.Reservas.Atrasados3.Valor.toFixed(2)]
                            },
                            {
                                label: "+60 dias de atraso",
                                backgroundColor:["#3B3A6D"],
                                data: [this.Atrasados.Reservas.Expirado.Valor.toFixed(2)]
                            },
                        ]
                    },
                    options: {
                        tooltips: {
                            enabled: true,
                            mode: 'single',
                            callbacks: {
                                label: (tooltipItems,data) => data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})
                            }
						},
                        legend: { 
                            display: true,
                            position: "bottom",
                            labels:{
                                padding: 25
                            }
                        },
                        title: {
                            display: false,
                            text: 'Investimentos'
                        },
                        responsive: true,
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(label, index, labels) {
                                        return label == '0' ? '0' : 'R$ ' + label.toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 2}) 
                                    }
                                }
                            }]
                        },
                    }
                });

                // Bar chart Rendimento geral da carteira
                new Chart(document.getElementById("GraficoRendimentoGeral"), {
                    type: 'bar',
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: "Valor total investido",
                                backgroundColor: ["#434272"],
                                data: [this.Rendimento.Investido.Valor.toFixed(2)]
                            },
                            {
                                label: "Rendimentos a receber",
                                backgroundColor:["#36D4BD"],
                                data: [(this.Rendimento.AReceber.Valor-this.Atrasados.Valor).toFixed(2)]
                            },
                            {
                                label: "Rendimento recebido",
                                backgroundColor:["#68C700"],
                                data: [this.Rendimento.Recebido.Valor.toFixed(2)]
                            },
                            {
                                label: "Rendimento em atraso",
                                backgroundColor:["#FF453A"],
                                data: [this.Atrasados.Valor.toFixed(2)]
                            },
                            {
                                label: "Multa/Mora",
                                backgroundColor:["#FFBB00"],
                                data: [this.Rendimento.Multa.Valor.toFixed(2)]
                            },
                        ]
                    },
                    options: {
                        tooltips: {
                            enabled: true,
                            mode: 'single',
                            callbacks: {
                                label: function(tooltipItems,data) {
                                    
                                    return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) ;
                                }
                            }
						},
                        legend: { 
                            display: true,
                            position: "bottom",
                            fontSize: "16px"
                        },
                        title: {
                        display: false,
                        text: 'Investimentos por score'
                        },
                        responsive: false,
                        scales: {
                            xAxes: [{
                            categoryPercentage: 1.0,
                            barPercentage: 0.3,
                            gridLines: {
                                display: false
                            }
                            }],
                            yAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                beginAtZero: true,
                                callback: function(label, index, labels) {
                                                    if(label == '0') {
                                                        return '0'
                                                    }
                                                    return 'R$ ' + label.toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 2}) 
                                                }
                            }
                            }]
                        },
                    }
                });

                //Doughnut chart Rendimento Geral da Carteira
                    // new Chart(document.getElementById("GraficoRendimentoGeral"), {
                    //     type: 'doughnut',
                    //     data: {
                    //         labels:["Valor Total Investido", "Rendimento Recebido", "Rendimento em Atraso","Rendimento a Receber","Multas e Atrasos"],
                    //         datasets:[
                    //             {
                    //                 label:["Teste"],
                    //                 backgroundColor: ["#434371", "#6FC30D", "#FF4949","#41D3BD", "#FFB928"],
                    //                 data: [this.Estatisticas.TotalInvestido, this.Estatisticas.TotalRendimentoRecebido, this.Estatisticas.TotalRendimentoAtrasado, this.Estatisticas.TotalRendimento, this.Estatisticas.TotalRendimentoMulta],
                    //                 borderWidth: [0, 0, 0, 0, 0]
                    //             }
                    //         ]
                    //     },
                    //     options: {
                    //        tooltips: {
                    //             enabled: true,
                    //             mode: 'single',
                    //             callbacks: {
                    //                 label: function(tooltipItems,data) {
                    //                     return data.labels[tooltipItems.index] + ' - ' + data.datasets[0].data[tooltipItems.index].toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2,  style: 'currency', currency: 'BRL'}) ;
                    //                 }
                    //             }
                    //         },
                    //         responsive: true,
                    //         legend:{
                    //             position: "bottom",
                    //             labels:{
                    //                 padding: 30
                    //             }
                    //         },
                    //         cutoutPercentage: 55
                    //     }
                // });

                //Bar chart Rendimento por Tipo de Investimento 
                // new Chart(document.getElementById("GraficoRendimentoTipo"), {
                    //     type: 'bar',
                    //     data: {
                    //         labels: ["Empréstimo Coletivo", "Empréstimo de Impacto", "Empréstimo Social", "Empréstimo Antecipado"],
                    //         datasets: [
                    //             {
                    //                 label: "Investimento Amortizado",
                    //                 backgroundColor: ["#6FC30D","#6FC30D","#6FC30D"],
                    //                 stack: 'Stack 0',
                    //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
                    //             },
                    //             {
                    //                 label: "Investimento Atrasado",
                    //                 backgroundColor: ["#FF4949","#FF4949","#FF4949"],
                    //                 stack: 'Stack 0',
                    //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
                    //             },
                    //             {
                    //                 label: "Investimento a Receber",
                    //                 backgroundColor: ["#434371","#434371","#434371"],
                    //                 stack: 'Stack 0',
                    //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
                    //             },
                    //             {
                    //                 label: "Rendimento",
                    //                 backgroundColor: ["#41D3BD","#41D3BD","#41D3BD"],
                    //                 stack: 'Stack 1',
                    //                 data: [(this.Rendimento.TotalInvestimentos.Valor - this.Rendimento.Investido.Valor),this.Rendimento.Recebido.Valor]
                    //             }
                    //         ]
                    //     },
                    //     options: {
                    //         tooltips: {
                    //             enabled: true,
                    //             mode: 'single',
                    //             callbacks: {
                    //                 label: function(tooltipItems,data) {
                                        
                    //                     return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) ;
                    //                 }
                    //             }
                    // 		},
                    //         responsive: true,
                    //         legend: {
                    //             display: true,
                    //             position: "bottom",
                    //             labels: {
                    //                 padding: 30
                    //             }
                    //         },
                    //         scales: {
                    //             xAxes: [{
                    //                 gridLines: {
                    //                     display: false
                    //                 },
                    //                 stacked: true
                    //             }],
                    //             yAxes: [{
                    //                 gridLines: {
                    //                     display: true,
                    //                     color: 'rgba(0, 0, 0, 0.1)'
                    //                 },
                    //                 ticks: {
                    //                     beginAtZero: true,
                    //                     callback: function(label, index, labels) {
                    //                             if(label == '0') {
                    //                                 return '0'
                    //                             }
                    //                             return 'R$ ' + label.toLocaleString('pt-BR', {minimumFractionDigits: "0", maximumFractionDigits: 2}) 
                    //                         }
                    //                 },
                    //                 stacked: true
                    //             }]
                    //         }
                    //     }
                // });
            },
            Status(status){
                if (status == "Carencia" || status == "ProximoMes"){
                    return "label bg-success text-white" 
                } else {
                    return "label bg-danger text-white" 
                } 
            },
            TextoStatus(status){
                if(status == "ProximoMes") return "Pagamento em dia"
                if(status == "Carencia") return "Em Carencia"
                if(status == "expirado") return "+61 dias de atraso"
                if(status <= 15) return "1 - 15 dias de atraso"
                if(status <= 30) return "16 - 30 dias de atraso"
                if(status <= 60) return "30 - 60 dias de atraso"
                return "Finalizado"
            },
            NomeEmpresa(nomeEmpresa){

                return nomeEmpresa

            },
            linkReserva(id){
                window.location.href='/#/investimentos/historico/historico-de-investimento/' + id
            },
            showMeInfo() {
                // Verifica se o investidor tem acesso as estatísticas
                // Verifica cadastro completo 
                if(this.User.hasinvestor && this.User.hassuitability && this.User.investor.Status == "APROVADO") {
                    this.showMeMsg = 1
                    return true
                } else {
                    if(this.User.hasinvestor && this.User.hassuitability){ this.showMeMsg = 2 }
                    else{ this.showMeMsg = 3 }
                    return false
                }
            },
            formataRegistrosVazios(Registro){
                if (Registro.Numero == 0) {
                    Registro.Valor = 0
                }
                return Registro
            },
            formatarAtrasos(Atrasados){
                let Reservas = {
                    Atrasados1:{
                        Valor: 0,
                        Numero: 0,
                        Reservas:[]
                    },
                    Atrasados2:{
                        Valor: 0,
                        Numero: 0,
                        Reservas:[]
                    },
                    Atrasados3:{
                        Valor: 0,
                        Numero: 0,
                        Reservas:[]
                    },
                    Expirado:{
                        Valor: 0,
                        Numero: 0,
                        Reservas:[]
                    }
                }
                Atrasados.Reservas.forEach(reserva => {
                    if(reserva.Status <= 15){
                        Reservas.Atrasados1.Valor += reserva.ValorRetorno
                        Reservas.Atrasados1.Numero ++
                        Reservas.Atrasados1.Reservas.push(reserva)
                    } else
                    if(reserva.Status <= 30){
                        Reservas.Atrasados2.Valor += reserva.ValorRetorno
                        Reservas.Atrasados2.Numero ++
                        Reservas.Atrasados2.Reservas.push(reserva)
                    } else
                    if(reserva.Status <= 60){
                        Reservas.Atrasados3.Valor += reserva.ValorRetorno
                        Reservas.Atrasados3.Numero ++
                        Reservas.Atrasados3.Reservas.push(reserva)
                    } else {
                        Reservas.Expirado.Valor += reserva.ValorRetorno
                        Reservas.Expirado.Numero ++
                        Reservas.Expirado.Reservas.push(reserva)
                    }
                });
                Atrasados.Reservas = Reservas
                return Atrasados
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/estatisticas/',
                    title: 'estatisticas home',
                })
            },
        },
        updated(){ 
            if(!this.Criou) {
                this.CriaGrafico()
                this.Criou = true
            }
        },
        beforeCreate() {
            this.$store.dispatch('updateUser')
        },
        async created(){
            this.$store.commit(mutationTypes.START_LOADING)
            
            if(this.$store.state.currentUser.investor != null){
                if(typeof this.$store.state.currentUser.investor.Bloqueio != 'undefined')
                    window.location.href="#/"
            }
            this.User = this.$store.state.currentUser;
            ApiClientGo.gerarEstatistica(this.User.investor._id)
            .then((resposta) => {
                if(typeof resposta.data.Rendimento == 'undefined'){
                    this.Estatisticas = 'Não Possui Investimentos'
                }else{
                    this.TIR = resposta.data.MediaRendimento
                    this.CDI = resposta.data.RendimentoCDI

                    this.Scores = resposta.data.Scores
                    this.TipoInvestimento = resposta.data.TipoInvestimento
                    this.Rendimento = resposta.data.Rendimento

                    let Atrasados = this.formataRegistrosVazios(resposta.data.Atrasados)

                    this.ProximoMes = this.formataRegistrosVazios(resposta.data.ProximoMes)
                    this.EsteMes = this.formataRegistrosVazios(resposta.data.EsteMes)
                    this.Carencia = this.formataRegistrosVazios(resposta.data.Carencia)

                    let Reservas = [...this.ProximoMes.Reservas]
                    Reservas = [...Reservas, ...this.EsteMes.Reservas]
                    Reservas = [...Reservas, ...this.Carencia.Reservas]
                    Reservas = [...Reservas, ...Atrasados.Reservas]
                    this.AuxHistoricoReservas = Reservas
                    this.HistoricoReservas = Reservas.slice(0,5)
                    this.Atrasados = this.formatarAtrasos(Atrasados)
                    this.ValorExpirados = this.Atrasados.Valor + this.Rendimento.AReceber.Valor - this.Rendimento.TotalInvestimentos.Valor
                    this.Estatisticas = 'Possui Investimentos'
                }
                this.Renderizou = true;

                this.$store.commit(mutationTypes.STOP_LOADING);
            }); 
            //tagueamento GA
            await this.taggingGA();  
        }
    }
</script>

<style lang="scss" scoped>
    .lower-item{
        border-top:1px solid #ddd;
    }

    .loader {
        margin: auto;
        margin-top: 20px;
        border: 12px solid #f3f3f3;
        border-top: 12px solid #41d3bd ;
        border-radius: 50%;
        width: 90px;
        height: 90px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .socialrating{
        background-color:#52B3D9; 
    }

    table {
        margin-bottom: 0px;
        tr {
            border-color: #e9ecef;
        }
        td {
            border-top: none;
        }
        thead {
            th {
                font-size: 14px;
                text-align: center;
                vertical-align: middle!important;

                &:nth-child(1) {
                    width:8%;
                }
                &:nth-child(2) {
                    width:7%;
                }
                &:nth-child(4) {
                    width:15%;
                }
                &:nth-child(5) {
                    width:10%;
                }
                &:nth-child(6) {
                    width:10%;
                }
                &:nth-child(7) {
                    width:15%;
                }
            }
        }

        tbody {
            th,
            td {
                vertical-align: middle!important;
                font-size: 14px;
            }
            td {
                text-align: center;
                color:#999;
                &:nth-child(3) {
                    div {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }       
    }

    .InfoGrafico:hover{
        color:#41D3BD!important;
    }

    div .ValorTotalInvestido{
        height: 10px;
        width: 25px;
        display: inline-block;
        background-color: #434371;
    }

    div .RendimentoRecebido{
        height: 10px;
        width: 25px;
        display: inline-block;
        background-color: #65BD00;
    }

    div .RendimentoAtrasado{
        height: 10px;
        width: 25px;
        display: inline-block;
        background-color: #FF4949;
    }

    div .RendimentoReceber{
        height: 10px;
        width: 25px;
        display: inline-block;
        background-color: #41D3BD;
    }

    div .MultasAtrasos{
        height: 10px;
        width: 25px;
        display: inline-block;
        background-color: #FFB928;
    }

    .Legenda{
        text-align: justify;
    }
    .LegendaFooter{
        font-size: 12px;
    }

</style>


// WEBPACK FOOTER //
// src/views/StatisticsHome.vue